import React, { useState, useCallback, useEffect, useRef } from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import FooterServices from '../../services/footer.service'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../components/Modal/Modal'
import { useModal } from 'react-modal-hook'
import { useHistory } from 'react-router-dom'
import NeoButton from '../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import { BUTTON_KEYS, EXCHANGE_RATES_KEYS } from '../../utils/translation-constants'

export default function ExchangeRates() {
  const [exchangeDetails, setExchangeDetails] = useState([])
  const [stage, setStage] = useState(0)
  const history = useHistory()
  const [message, setMessage] = useState('')
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6 className='text-center'>{message}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton
            type='button'
            mode='newDesign'
            text={t(BUTTON_KEYS.CLOSE)}
            onClick={() => {
              hideModal()
              history.push('/dashboard')
            }}
          />
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    getExchangeRatesDetails()
  }, [])

  const getExchangeRatesDetails = useCallback(
    async (values) => {
      try {
        setStage(0)
        const response = await FooterServices.getExchangeRatesDetails(values)
        if (response.status === 200) {
          setExchangeDetails(response.data.crossCurRateList)
          setStage(1)
        }
      } catch (err) {
        setStage(1)
        // setMessage(err.data.message)
        // //showModal()
      }
    },
    [showModal],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderExchangeRatesForm()
      default:
        return renderLoading()
    }
  }

  function renderExchangeRatesForm() {
    return (
      <div>
        <div>
          <div className='heading5'>
            <div className='headingCell5'>{t(EXCHANGE_RATES_KEYS.CONVERSION_TYPE)}</div>
            <div className='headingCell5'>{t(EXCHANGE_RATES_KEYS.BUY_PRICE)}</div>
            <div className='headingCell5'>{t(EXCHANGE_RATES_KEYS.SELL_PRICE)}</div>
          </div>
          {exchangeDetails.map((item, index) => (
            <div className='row5' key={index}>
              <div className='cell5'>{item.symbol}</div>
              <div className='cell5'>{item.buyRate}</div>
              <div className='cell5'>{item.saleRate}</div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='EXCHANGE_RATES'
      showEmptySpace={true}
      keyPath={'EXCHANGE_RATES'}>
      <div className=''>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
